import React from 'react';
import { useSelector } from 'react-redux';
const HeaderApp = () => {
    const user = useSelector(state => state.user)
    console.log(user)
    return (
        <div className='header-app'>
            <p>{user.userData.name}</p>
            <img src={user.userData.photo} alt="" />
        </div>
    );
};

export default HeaderApp;